import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from '../common/Table';
import SearchForm from './SearchForm';

export default class Mails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mails: [],
            searchConditions: {},
            lastPage: 1,
            currentPage: 1,
            removeDirectlyClick: 1,
            from: '',
            to: '',
            total: '',
        };
        this.handleSearch = this.handleSearch.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleSendMail = this.handleSendMail.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleDetail = this.handleDetail.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }
    
    /**
     * Init data and form mails or list mails
     */
    componentWillMount() {
        const keySearch_str = this.props.location.search.substring(1);
        let keySearch_arr = {page: 1};
        if (keySearch_str) {
            keySearch_arr = JSON.parse('{"' + decodeURI(keySearch_str.replace(/&/g, "\",\"")).replace(/=/g,"\":\"").replace('%3A', ':') + '"}');
        }
        
        //always get list data
        axios.post('/api/mails/search', keySearch_arr).then(response => {
            this.setState({
                mails: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                searchConditions: keySearch_arr,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: keySearch_str
            });
        });
        
    }
    
    /**
     * Sort data
     */
    handleSort(key) {
        //add sort params to search conditions
        let newSearchConditions = this.state.searchConditions;
        newSearchConditions.sort_column = key.sort_column;
        newSearchConditions.sort_type = key.sort_type;
        this.setState({
            searchConditions: newSearchConditions
        });
        axios.post('/api/mails/search', newSearchConditions).then(response => {
            this.setState({
                mails: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(newSearchConditions)
            });
        });
    }
    
    /**
     * Edit mail
     * client: Object Mail
     */
    handleEdit(mail) {
        this.props.history.push('/mails/edit/' + mail.id);
    }
    
    /**
     * Detail mail
     * mail: Object Mail
     */
    handleDetail(mail) {
        this.props.history.push('/mails/view/' + mail.id);
    }
    
    /**
     * Send mail
     * client: Object Mail
     */
    handleSendMail(mail) {
        if (window.confirm('このメールを配信しますか？')) {
            $('.cover-loading').removeClass('block-hidden');
            axios.post('/api/mails/send-mail', mail).then(response => {
                location.reload();
            });
        } 
    }
    
    /**
     * Get search data
     */
    handleSearch(key) {
        this.setState({
            searchConditions: key
        });
        axios.post('/api/mails/search', key).then(response => {
            this.setState({
                mails: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(key)
            });
        });
        
    }
    
    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }
    
    render () {
        const option = {
            null:{text:'未承認'},
            1:{text:'全シェアジョブ ユーザー(承認者のみ)'},
            2:{text:'全ワーカー(承認者のみ)'},
            3:{text:'全依頼者(承認者のみ)'},
            4:{text:'全依頼者・法人(承認者のみ)'},
            5:{text:'テストメール配信(エントリーのみ)'},
            6:{text:'依頼者個別配信'},
            7:{text:'ワーカー個別配信'},
        };
        const option_type = {
            null:{text:'未承認'},
            1:{text:'メール配信'},
        };
        const columns = [
            {name: 'id', title: 'ID', isSort: 1, type: 'text'},
            {name: 'destination', title: '宛先', isSort: 1, type: 'option_destination', option:option},
            {name: 'type', title: '配信タイプ', isSort: 1, type: 'option', option: option_type},
            {name: 'title', title: 'タイトル', isSort: 1, type: 'text'},
            {name: 'content', title: '内容', isSort: 0, type: 'text_limit'},
            {name: 'created_at', title: '作成日時', isSort: 1, type: 'date_time'},
            {name: 'send_date', title: '送信日時', isSort: 1, type: 'date_time'},
            {name: '', title: '編集/閲覧', isSort: 0, type: 'btn_edit'},
            {name: 'status', title: '配信', isSort: 0, type: 'btn_status'},
        ];
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item active" aria-current="page">メール配信</li>
                            </ol>
                        </nav>
                    </div>
		</div>

		<main id="main">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h4 className="mt-2 mb-0 page-title">メール配信</h4>
                                        </div>
                                        <div className="col text-right">
                                            <a onClick={this.handleRedirect} href="/mails/create" className="btn btn-warning btn-space">メール配信登録</a>
                                            <button className="btn btn-light" type="button" data-toggle="collapse" data-target="#search-mails" aria-expanded="false" aria-controls="search-mails">絞込検索</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <SearchForm onSearch={this.handleSearch} />
                                        </div>
                                    </div>
                                </div>
                                <Table onSearch={this.handleSearch} data={this.state.mails} header={columns} onSendMail={this.handleSendMail} onEdit={this.handleEdit} removeClick={this.state.removeDirectlyClick}
                                    myPagination={1} searchConditions={this.state.searchConditions} lastPage={this.state.lastPage} currentPage={this.state.currentPage} onDetail={this.handleDetail} onSort={this.handleSort} from={this.state.from} to={this.state.to} total={this.state.total} />
                            </div>
                        </div>
                    </div>
                    <div className="block-hidden cover-loading"><span>処理中...</span></div>
		</main>
            </React.Fragment>
        );
    }
}
